import defaultMember from '@hc-frontend/shared-assets/src/js/sem/storage-manager/defaultMember'
import getMemberIdBySuffix from 'utils/pivot/member/getMemberIdBySuffix'
import saveSalesForceId from 'utils/pivot/saveSalesForceId'
import storage, { WebStorage } from 'proxy-storage'
import { dateToString } from '@hc-frontend/utils'
import { findChildren, findSpouse } from '@hc-frontend/business'
import { convertToMember } from 'utils/pivot/member/convertToMember/convertToMember'
import { MemberType } from '@hc-frontend/entities'

const sessionStorage = new WebStorage('sessionStorage')

function saveToStorage(valuesForm) {
  const hcStorage = storage.getItem('hc')
  const applicant = hcStorage.members[0]
  applicant.id = applicant.id || MemberType.Applicant.toLowerCase()
  hcStorage.members.shift()
  const spouse = findSpouse(hcStorage.members)
  const childrenLeft = findChildren(hcStorage.members)
  childrenLeft.forEach((child, idx) => {
    child.id = `child_${idx + 1}`
  })
  const members = [applicant, spouse, ...childrenLeft].filter(Boolean)

  hcStorage.lastHealthcareSession = hcStorage.healthcareSession
  hcStorage.censusUrgency = valuesForm.censusUrgency
  hcStorage.contact.first_name = valuesForm.fname
  hcStorage.contact.email_address = valuesForm.email
  hcStorage.contact.phone_home = valuesForm.phone
  hcStorage.childOnly = valuesForm.childOnly
  hcStorage.childOnlySMT = valuesForm.childOnlySMT
  const sdateAsString = dateToString(valuesForm.sdate)
  if (hcStorage.sdate != sdateAsString) {
    hcStorage.sdate = sdateAsString
    hcStorage.endDate = ''
  }

  for (const key in valuesForm) {
    const [inputName, suffix] = key.split('_')

    if (inputName === 'dob' || inputName === 'gender') {
      const ids = getMemberIdBySuffix(suffix)

      let member = members.find(person => person.id === ids.id)

      if (!member) {
        member = Object.assign({}, defaultMember, ids)
        members.push(member)
      }

      member[inputName] = valuesForm[key]
    }
  }

  members[0].firstName = valuesForm.fname

  hcStorage.members = convertToMember(members)
  hcStorage.household.size = members.length

  if (valuesForm.period) {
    hcStorage.period = valuesForm.period
  }

  if (
    window.LeadiD &&
    window.LeadiD.token &&
    valuesForm.showPhoneInput &&
    valuesForm.phone
  ) {
    sessionStorage.setItem('pivotJornayaLeadIdToken', window.LeadiD.token)
  }

  saveSalesForceId(hcStorage.contact.email_address)

  storage.setItem('hc', hcStorage)

  return hcStorage
}

export default saveToStorage
